/* Polyfill function to support ie11 */

export function trimLeft(str: string) {
  return str.replace(/^\s+/, '')
}

export function trimRight(str: string) {
  return str.replace(/\s+$/, '')
}
